module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01-1"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "images",
      "id": "img10",
      "src": "images/img10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The site of Tyburn Tree on the traffic island at the junction of Edgeware Road with Bayswater and Oxford Street, close to Marble Arch. A bronze plaque, close to the bollard in the right foreground, marks the spot. ")]), _c('span', {
    staticClass: "fontS"
  }, [_vm._v("The author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a19d3512","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/08a_Fouldeeds_ch011.vue
// module id = 90
// module chunks = 0